import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from './styles';

const SContainer = styled(Container)`
  ${props => !props.theme.isMobileOrTablet && `
    margin-top: auto;
    margin-left: auto;
  `};

  ${props => props.theme.isMediumXLarge && !props.theme.isXLarge && `
    &.has-performance-fee {
      margin-bottom: 12px;
    }
  `};

  ${props => !props.theme.isMediumXLarge && `
    margin-top: 16px;
  `};

  ${props => props.theme.isMobile && `
    margin-top: 0;
  `};
`;

const Text = styled.div`
  font: ${props => props.theme.fontWeightRegular} 16px/120% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;

  ${props => props.theme.isMobile && `
    font-size: 14px;
  `};
`;

export default function Code({ codeLabel, code, hasPerformanceFee }) {
  return (
    <SContainer className={hasPerformanceFee ? 'has-performance-fee' : ''}>
      <Text>{codeLabel ? `${codeLabel}: ${code}` : code}</Text>
    </SContainer>
  );
}

Code.propTypes = {
  codeLabel: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  hasPerformanceFee: PropTypes.bool.isRequired,
};
